import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { z } from 'zod'

import Logo from '@/containers/logo'

import Spinner from '@/components/spinner'
import { ModeToggle } from '@/components/theme/mode-toggle.tsx'

import { authTokenAtom } from '../../state/authToken'
import { useIdentity } from '../../state/identity'

import LoginForm from './-components/loginForm'

const Login = () => {
    const { identity } = useIdentity()
    const [authToken] = useAtom(authTokenAtom)
    const router = useRouter()
    const { redirect } = Route.useSearch()

    useEffect(() => {
        if (identity) {
            console.debug('Identified, redirecting')
            // Hard refresh redirect on login do avoid potential state issues
            location.href = redirect ?? '/'
        }
    }, [identity, redirect, router.history])

    if (identity || authToken) {
        return <Spinner size="sm" absolute />
    }

    return (
        <>
            <div className="relative grid h-screen flex-col items-center justify-center px-4 lg:max-w-none lg:grid-cols-2 lg:px-0">
                <div className="absolute right-8 top-8">
                    <ModeToggle />
                </div>
                <div className="mx-auto hidden h-full w-full flex-col items-center justify-center bg-muted lg:flex">
                    <Logo className="mb-4 mr-2" />
                    <h1 className="text-2xl font-semibold tracking-tight">Moxie Markets</h1>
                </div>
                <div className="lg:p-8">
                    <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
                        <div className="visible mx-auto mb-12 flex w-full flex-col items-center justify-center text-center lg:hidden">
                            <Logo className="mb-4 mr-2" />
                            <h1 className="text-2xl font-semibold tracking-tight">Moxie Markets</h1>
                        </div>
                        <div className="flex flex-col space-y-2 text-center">
                            <h1 className="text-2xl font-semibold tracking-tight">Log in</h1>
                        </div>
                        <LoginForm />
                    </div>
                </div>
            </div>
        </>
    )
}

const loginSearchSchema = z.object({
    redirect: z.string().optional(),
})

export const Route = createFileRoute('/login/')({
    validateSearch: loginSearchSchema,
    component: Login,
})
